export class ItemDetailModel {

  public itemId: number;

  public clientId: string;

  public title: string;

  public categoryId1: number;

  public categoryId2: number;

  public releaseDate: string;

  public imageList: Array<string>;

  public makerSite: string;

  public clientFileName: string;

  public maker: string;

  public brand: string;

  public storeList: Array<StoreInfo>;

  public priceFileName: string;

  public buyerRecommendFlag: boolean;

  public buyerRecommendFileName: string;

  public publishDate: string;

}

export class StoreInfo {
  public area: string;
  public stores: Array<Store>;
}

export class Store {
  public name: string;
  public internalStoreCode: string;
  public storeId: number;
  public deepLinkUrl: string;
}

